export default __webpack_public_path__ + "static/media/AssessmentReport.d0f11fc9.svg";